import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { LomaParser } from "../../../library-js/rj/parsers/Loma/LomaParser";
import { LomaEvaluator } from "../../../library-js/rj/parsers/Loma/LomaEvaluator";
import { LomaDoc } from "../../../library-js/rj/parsers/Loma/LomaDoc";

import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { OnChange, OnInput, OnKeyDown, OnKeyUp, OnMouseDown, OnMouseUp } from "../../../library-js/dom-tools/EventListeners";
import { Message } from "../../../library-js/messages/Message";
import { MessageToHTML } from "../../../library-js/messages/MessageToHTML";
import { MessageTypes } from "../../../library-js/messages/MessageType";
import { MessageReader } from "../../../library-js/messages/MessageReader";
import { Range } from "../../../library-js/geometry/Range";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { Stringifier } from "../../../library-js/rj/parsers/Loma/Stringifier";

export class RJParserTest
{
  static readonly type = new ElementType( "rj-parser-test" );
  static readonly result = new ElementType( "rj-parser-result" );
  static readonly parsed = new ElementType( "rj-parsed" );
  static readonly docArea = new ElementType( "doc-area" ); 
 
  static lomaEvaluator = new LomaEvaluator();
  static lomaDoc:LomaDoc;


  static applyOnDocument()
  {
    RJParserTest.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( e:Element )
  {    
    if ( ! RJParserTest.lomaDoc )
    {
      this.lomaDoc = new LomaDoc();
      this.lomaDoc.createFrom( this.lomaEvaluator );
    }

    let input = AttributeValue.type_text.query( e ) as HTMLInputElement;

    OnChange.add( input, () => RJParserTest.parse( e, input ) );
    OnInput.add( input, () => RJParserTest.parse( e, input ) );
    OnKeyDown.add( input, () => RJParserTest.parse( e, input ) );
    OnKeyUp.add( input, () => RJParserTest.parse( e, input ) );
    OnMouseDown.add( input, () => RJParserTest.parse( e, input ) );
    OnMouseUp.add( input, () => RJParserTest.parse( e, input ) );

    RJParserTest.parse( e, input );

    let docArea = this.docArea.query( e );

    if ( docArea )
    {
      docArea.appendChild( this.lomaDoc.createHTML() );
    }
  }

  static parse( e:Element, input:HTMLInputElement )
  {
    let parser = new LomaParser();
    let resultElement = RJParserTest.result.query( e );
    let parsed = RJParserTest.parsed.query( e );

    console.log( "parsing:" + input.textContent );
    parser.parse( input.value );

    let tokens = parser.createTokens.tokens;

    parsed.innerHTML = "";
    resultElement.innerHTML = "";
    ClassFlag.error.removeFrom( resultElement );
    
    if ( ! tokens )
    {
      resultElement.appendChild( document.createTextNode( "Invalid input" ) );
      ClassFlag.error.set( resultElement );
      return;
    }

    if ( tokens.length === 0 )
    {
      resultElement.appendChild( document.createTextNode( "Type something" ) );
      ClassFlag.error.set( resultElement );
      return;
    }

    let types = new Map<string,ElementType<Element>>();

    let selectionMin = Math.min( input.selectionStart, input.selectionEnd );
    let selectionMax = Math.max( input.selectionStart, input.selectionEnd );

    let caretPosition = input.selectionDirection === "backward" ? selectionMax : selectionMin;
    let characterIndex = 0;

    let selectionRange = new Range( selectionMin, selectionMax );

    let caretElement:Element = null;
    let caretElementIndex = 0;
    let caretText = "";

  

    for ( let i = 0; i < tokens.length; i++ )
    {
      if ( ! types.has( tokens[ i ].tokenType ) )
      {
        types.set( tokens[ i ].tokenType, new ElementType( "rj-" + tokens[ i ].tokenType ) );  
      }

      let text = tokens[ i ].match;
      let type = types.get( tokens[ i ].tokenType );
      let element = type.create( text ) as HTMLElement;

      element.style.display = "inline-block";
      element.style.position = "relative";
      

      parsed.appendChild( element );

      let caretIndexStart = characterIndex;

      characterIndex += text.length;

      let elementRange = new Range( caretIndexStart, characterIndex );

      if ( elementRange.contains( caretPosition ) )
      {
        caretElementIndex = caretIndexStart;
        caretElement = element;
        caretText = text;
      }

    }

    let caret = new ElementType<HTMLElement>( "caret-box" ).create();

    caret.setAttribute( "selection", caretPosition + ">>" + selectionMin + "," + selectionMax );
    ( parsed as HTMLElement ).style.position ="relative";
    
    caret.style.position = "absolute";
    caret.style.display = "block";
    caret.style.left  = "0px";
    caret.style.top   = "0px";
    caret.style.width = "0.1em";
    caret.style.height = "1em";
    caret.style.background = "yellow";

    
    if ( caretElement !== null )
    {
      let caretSubElement:HTMLElement = null;
      let subElementType = new ElementType<HTMLElement>( "text-element");

      caretElement.innerHTML = "";

      for ( let i = 0; i < caretText.length; i++ )
      {
        let subElement = subElementType.create( caretText[ i ] );

        subElement.style.display = "inline-block";
        subElement.style.position = "relative";

        if ( caretElementIndex + i === caretPosition )
        {
          caretSubElement = subElement; 
        }

        caretElement.appendChild( subElement );
      }
      
      if ( caretSubElement )
      {
        caretSubElement.appendChild( caret );
      }
      else
      {
        caret.style.position = "static";
        caret.style.display = "inline-block";

        parsed.appendChild( caret );
      }
      

    }
    else
    {
      if ( parsed.childNodes.length > 0 )
      {
        parsed.appendChild( caret );
      }

      
    }
    

    parser.lomaOperatorProcessor.parsedExpressions.forEach(
      ( exp )=>
      {
        parsed.appendChild( exp.createHTMLElement() );
      }
    )

    let reader = new MessageReader( parser.messages );

    if ( reader.hasErrors )
    {
      MessageToHTML.addTo( resultElement, parser.messages );
      ClassFlag.error.set( resultElement );
      return;
    }

    let evaluator = this.lomaEvaluator;

    let result = evaluator.evaluate( parser.lomaOperatorProcessor.parsedExpressions[ 0 ] );
    
    console.log( "Parsed", e, ">>", parser.messages, result );

    if ( result.success )
    {
      let output = Stringifier.stringify( result.data, result.type );
      resultElement.appendChild( document.createTextNode( output ) );
    }
    else
    {      
      MessageToHTML.addTo( resultElement, result.messages );
      ClassFlag.error.set( resultElement );
    }    

    
  }

}